import { Box, Typography } from "@mui/material"

const LandingPill = ({ icon: Icon, children, className = "" }) => (
    <Box className={`landing-pill ${className}`}>
        {Icon ? <Icon className="landing-pill__icon" /> : null}
        <Typography component="span" className="landing-pill__text">
            {children}
        </Typography>
    </Box>
)

export default LandingPill